// Single-switch payment gate configuration for the MVP preview.
// Flip PAID to true to instantly remove: the diagonal watermark, the
// preview top bar, the expiry screen, and every lock overlay.

export const PAID = false;

// ISO date OR ISO datetime. When only a date is given, expiry is
// treated as 23:59:59 of that day. Datetimes are honoured directly.
export const PREVIEW_EXPIRES = "2026-08-05T18:00:00";

// Overdue mode. When true, EVERY authenticated screen is locked
// (Dashboard, Properties, all property details, Documents, Contacts,
// Settings) and the top bar switches to a red overdue banner.
export const LOCK_ALL_SCREENS = true;

export const OVERDUE_MESSAGE = "Payment overdue — 12 hrs to fulfill";

export const ORDER_URL =
  "https://rockstarsdigitals.com/order/3b2fdb936b7564752e124134e36bf759f88b007835aa30bdd8369bd16f14fd99";

export const OWNERSHIP_NOTICE =
  "Concept, design and code remain the property of Rockstars Digitals until payment has been received in full.";

function getExpiryDate() {
  const raw = PREVIEW_EXPIRES;
  return raw.includes("T") ? new Date(raw) : new Date(`${raw}T23:59:59`);
}

// Returns true when the preview window has already ended.
export function isPreviewExpired(today = new Date()) {
  if (PAID) return false;
  return today.getTime() > getExpiryDate().getTime();
}

// Legacy — days remaining, ceil.
export function daysUntilExpiry(today = new Date()) {
  const ms = getExpiryDate().getTime() - today.getTime();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

// Richer time breakdown for the top bar. Returns { expired, days, hours,
// totalMs }. `days` is present when > 24h remain, otherwise `hours` is
// used. Ceil-based so users see the friendlier higher number.
export function timeUntilExpiry(today = new Date()) {
  const ms = getExpiryDate().getTime() - today.getTime();
  if (ms <= 0) return { expired: true, days: 0, hours: 0, totalMs: 0 };
  const totalHours = ms / (1000 * 60 * 60);
  if (totalHours >= 24) {
    return {
      expired: false,
      days: Math.ceil(totalHours / 24),
      hours: 0,
      totalMs: ms,
    };
  }
  return {
    expired: false,
    days: 0,
    hours: Math.max(1, Math.ceil(totalHours)),
    totalMs: ms,
  };
}
